<template>
	<div id="meetdetails">
		<div v-loading="loading" :element-loading-text="loadingText">
			<div class="top">
				<div class="title">会议主题：{{MeetingDetail.meetingTitle}} <i></i> </div>
				<div class="tabs" v-if="meetStatus == 'WAIT'||meetStatus == 'WAIT_CLAIM'||meetStatus == 'LIVING'">
					<template v-for="(item,i) in list2">
						<p :class="item.class == curNow ? 'active':''" :key="i" @click="tabsChange(item)">
							<b :class="`tab${item.class}`">{{item.name}}</b>
							<i></i>
						</p>
						<el-divider direction="vertical" :key="i" v-if="i<list.length-1"></el-divider>
					</template>
				</div>
				<div class="tabs" v-else>
					<template v-for="(item,i) in list">
						<p :class="item.class == curNow ? 'active':''" :key="i" @click="tabsChange(item)">
							<b :class="`tab${item.class}`">{{item.name}}</b>
							<i></i>
						</p>
						<el-divider direction="vertical" :key="i" v-if="i<list.length-1"></el-divider>
					</template>
				</div>
			</div>
			<div class="laborProgress" label="会议医生信息" v-if="curNow=='1'">
				<div class="lpBox">
					<el-table :data="userList" style="width: 100%">
						<el-table-column prop="fullName" label="姓名" align="cneter" min-width="200"></el-table-column>
						<el-table-column prop="phoneNumber" label="手机号" align="cneter"
							min-width="200"></el-table-column>
						<el-table-column prop="title" label="职称" align="cneter" min-width="200"></el-table-column>
						<el-table-column prop="hospital" label="医院" align="cneter" min-width="200"></el-table-column>
						<!-- <el-table-column label="四证查看" align="cneter" width="160">
							<template slot-scope="scope">
								<el-button size="mini" @click="viewCertificate(scope.row)">查看</el-button>
								<el-dialog v-if="certificateShow" title="四证查看" :visible.sync="certificateShow"
									width="600px">
									<el-image v-for="(url,i) in certificateList" :key="i" :src="url"
										:preview-src-list="certificateList"
										style="width: 100px; height: 100px; margin: 5px;" fit="cover">
									</el-image>
								</el-dialog>
							</template>
						</el-table-column> -->
					</el-table>

				</div>
			</div>
			<div class="conferenceReplay" label="劳务明细" v-if="curNow=='2'">
				<div class="crBox">
					<div class="opts"
						v-if="MeetingDetail.meetingStatus!='WAIT'&&MeetingDetail.meetingStatus!='LIVING'&&MeetingDetail.meetingStatus!='SUCCESS'">
						<el-link target="_blank" type="primary"
							href="//life-oasis.oss-cn-beijing.aliyuncs.com/video/newtemplate/%E5%8A%B3%E5%8A%A1%E5%8D%8F%E8%AE%AE%E6%98%8E%E7%BB%86.xlsx">下载劳务明细模版</el-link>
						<el-upload class="upload" :action="`${baseUrl}/sign/live/assistant/importMeetingOrder`"
							:data="{meetingId:$route.query.mId}" :headers="{token:token}" multiple
							:on-progress="onProgress" :on-success="File6Success" :show-file-list="false">
							<el-button size="mini" type="primary" class="uploadFile">上传</el-button>
						</el-upload>
					</div>

					<!-- 劳务明细 -->
					<el-table :data="orderList.orders" key="orderTable" style="width: 100%">
						<el-table-column prop="fullName" label="姓名" align="center" width="100"></el-table-column>
						<el-table-column prop="meetingTitle" label="会议主题" min-width="200">
							<template slot-scope="scope">
								<span v-if="scope.row.orderType=='system'">{{MeetingDetail.meetingTitle}}</span>
								<span v-else>{{scope.row.meetingTitle}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="cardId" label="身份证号" min-width="150"></el-table-column>
						<el-table-column prop="bankNumber" label="银行卡号" min-width="150"></el-table-column>
						<el-table-column prop="bankName" label="开户行" width="200"></el-table-column>
						<el-table-column label="协议状态" width="80" align="center">
							<template slot-scope="scope">
								<el-tag size="mini" type="primary"
									v-if="scope.row.agreementStatus == 'WAIT'">待签署</el-tag>
								<el-tag size="mini" type="info" v-if="scope.row.agreementStatus == 'END'">已取消</el-tag>
								<el-tag size="mini" type="success"
									v-if="scope.row.agreementStatus == 'FINISH'">已签署</el-tag>
								<el-tag size="mini" type="success"
									v-if="scope.row.agreementStatus == 'SIGNED'">已签署</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="劳务状态" width="80" align="center">
							<template slot-scope="scope">
								<el-tag size="mini" type="primary" v-if="scope.row.orderStatus == 'WAIT'">待支付</el-tag>
								<el-tag size="mini" type="info" v-if="scope.row.orderStatus == 'END'">已取消</el-tag>
								<el-tag size="mini" type="danger" v-if="scope.row.orderStatus == 'ERROR'">已驳回</el-tag>
								<el-tag size="mini" type="danger" v-if="scope.row.orderStatus == 'REJECT'">已驳回</el-tag>
								<el-tag size="mini" type="success" v-if="scope.row.orderStatus == 'FINISH'">已支付</el-tag>
								<el-tag size="mini" type="primary"
									v-if="scope.row.orderStatus == 'PROGRESS'">进行中</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="preTax" label="税前金额" width="100" align="center"></el-table-column>
						<el-table-column prop="afterTax" label="税后金额" width="100" align="center"></el-table-column>
						<el-table-column prop="orderType" label="劳务所属会议" width="120" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.orderType=='system'">本会议</span>
								<span v-else>其他会议</span>
							</template>
						</el-table-column>

						<el-table-column label="操作" align="cneter" width="120" class="tableOpts">
							<template slot-scope="scope">
								<el-button @click="sendTextFun(agreementList[scope.$index])" size='mini' type="text"
									v-if="agreementList[scope.$index]&&agreementList[scope.$index].isSend=='NO'&&agreementList[scope.$index].status=='WAIT'">
									短信提醒
								</el-button>
								<el-button @click="sendTextFun(agreementList[scope.$index])" size='mini' type="text"
									v-else-if="agreementList[scope.$index]&&agreementList[scope.$index].isSend=='YES'&&agreementList[scope.$index].status=='WAIT'">
									再次提醒
								</el-button>
								<el-button size='mini' type="text" @click="changeDetailShowDlog(scope.row)"
									v-if="scope.row.orderType!='system'">修改</el-button>
								<el-button type="text" size="mini" @click="deleteDetail(scope.row)"
									v-if="scope.row.orderType!='system'">删除</el-button>
							</template>
						</el-table-column>
					</el-table>

					<el-row class="endNode">
						<el-col :span="6">
							<span>小计：</span>
						</el-col>
						<el-col :span="6" :offset="6">
							<span class="preAmount">¥{{orderList.preAmount?orderList.preAmount:0}}</span>
						</el-col>
						<el-col :span="6">
							<span class="amount">¥{{orderList.amount?orderList.amount:0}}</span>
						</el-col>
					</el-row>

				</div>
			</div>
			<div class="meetingDetails" label="会议详情" v-if="curNow=='3'">
				<div class="left">
					<el-row :gutter="20">
						<el-col :span="24">
							<p>会议主题</p>
							<div>{{MeetingDetail.meetingTitle}}</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p>所属项目</p>
							<div>{{MeetingDetail.projectName}}</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-if="MeetingDetail.reimbursementNum">
						<el-col :span="24">
							<p>金蝶单号</p>
							<div>{{MeetingDetail.reimbursementNum}}</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<p>会议类型</p>
							<div v-if="MeetingDetail.meetingFormat == 'TENCENT'">线上会</div>
							<div v-else-if="MeetingDetail.meetingFormat == 'OFFLINE'">线下会</div>
							<div v-else>仅管理</div>
						</el-col>
						<el-col :span="12">
							<p>会议天数</p>
							<div>{{ MeetingDetail.meetingDays || 1 }} 天</div>
						</el-col>
					</el-row>
					<!-- 会议日期单独一行: 起止相同只显示一次 -->
					<el-row :gutter="20">
						<el-col :span="24">
							<p>会议日期</p>
							<div v-if="MeetingDetail.meetingStartTime">
								{{ formatMeetingDateRange(MeetingDetail.meetingStartTime, MeetingDetail.meetingEndTime) }}
							</div>
							<div v-else>-</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8">
							<p>会议状态</p>
							<div>
								<el-tag size="small" :type="meetingStatusTagType(MeetingDetail.meetingStatus)">
									{{ meetingStatusLabel(MeetingDetail.meetingStatus) }}
								</el-tag>
							</div>
						</el-col>
						<el-col :span="8" v-if="MeetingDetail.meetingAddress">
							<p>会议地点</p>
							<div>{{ MeetingDetail.meetingAddress }}</div>
						</el-col>
						<el-col :span="8" v-if="MeetingDetail.meetingId">
							<p>会议编号</p>
							<div>{{ MeetingDetail.meetingId || MeetingDetail.id }}</div>
						</el-col>
					</el-row>

					<el-row :gutter="20" v-if="MeetingDetail.meetingFormat == 'OFFLINE'&&MeetingDetail.location">
						<el-col :span="12">
							<p>参会地点</p>
							<div>{{MeetingDetail.location.map(item=>item.trim()).join('/')}}</div>
						</el-col>
						<el-col :span="12">
							<p>详细地址</p>
							<div>{{MeetingDetail.position}}</div>
						</el-col>
					</el-row>
					<!-- <el-row :gutter="20" v-if="roleList">
					
				</el-row> -->
					<el-row :gutter="20" v-if="roleList">
						<el-col>
							<p>参会人员</p>
						</el-col>
						<el-col :span="24" v-for="(item,i) in MeetingDetail.users" :key="i">
							<p>{{roleList[i]}}</p>
							<div>
								<template v-for="(item2,k) in item">
									{{item2.fullName}}
									<template v-if="k < item.length-1">,</template>
								</template>
							</div>
						</el-col>
					</el-row>
				</div>

				<div class="center">
					<el-row :gutter="20">
						<el-col :span="24">
							<p>立项单位</p>
							<div>{{ MechanismList.deptName || MechanismList.orgName || MechanismList.mechanismName || MeetingDetail.mechanismName || '-' }}</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p>项目官员</p>
							<div v-if="MeetingDetail.officesIds">
								<template v-for="item in executive">
									<template v-if="user == item.id" v-for="(user,idx) in MeetingDetail.officesIds">
										{{item.fullName}}
										<template v-if="idx<MeetingDetail.officesIds.length -1">,</template>
									</template>
								</template>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-if="enterPriseList.deptName || enterPriseList.orgName || enterPriseList.enterpriseName">
						<el-col :span="24">
							<p>支持企业</p>
							<div>
								{{ enterPriseList.deptName || enterPriseList.orgName || enterPriseList.enterpriseName }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p>执行机构</p>
							<div>
								{{ orgList.deptName || orgList.orgName || orgList.actuatorName || MeetingDetail.actuatorName || '-' }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p>会务负责人</p>
							<div v-if="MeetingDetail.meetingActuatorIds">
								<template v-for="item in orgListUser">
									<template v-if="user == item.id"
										v-for="(user,idx) in MeetingDetail.meetingActuatorIds">
										{{item.fullName}}
										<template v-if="idx<MeetingDetail.meetingActuatorIds.length -1">,</template>
									</template>
								</template>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p>劳务负责人</p>
							<div v-if="MeetingDetail.laborActuatorIds">
								<template v-for="item in orgListUser">
									<template v-if="user == item.id"
										v-for="(user,idx) in MeetingDetail.laborActuatorIds">
										{{item.fullName}}
										<template v-if="idx<MeetingDetail.laborActuatorIds.length -1">,</template>
									</template>
								</template>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="right">
					<el-row :gutter="20">
						<el-col :span="24">
							<p>会议KV</p>
							<div>
								<el-image :src="MeetingDetail.coverImageUrl" fit="cover"
									:preview-src-list="srcList"></el-image>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p>直播间背景图</p>
							<div>
								<el-image :src="MeetingDetail.bgImage" fit="cover"
									:preview-src-list="srcList"></el-image>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p>会议海报</p>
							<div>
								<el-image :src="MeetingDetail.bill" fit="cover" :preview-src-list="srcList"></el-image>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="postMeetingUpload" label="会后上传" v-if="curNow=='4'">
				<div class="personalSettlement">
					<div class="card" @click="uploadPostMeetingDocuments">
						<i class="el-icon-s-claim"></i>
						个人劳务结算
					</div>
				</div>
				<div class="supplierSettlement"
					v-if="MeetingDetail.meetingStatus!='WAIT'&&MeetingDetail.meetingStatus!='WAIT_CLAIM'&&MeetingDetail.meetingStatus!='LIVING'">
					<div class="card" @click="settleAccountsShow = true" v-if="!orderData">
						<i class="el-icon-s-finance"></i>
						供应商结算
					</div>
					<template v-else>
						<div class="card" @click="supplierSettlement" v-if="orderData.status=='WAIT'">
							<i class="el-icon-document-remove"></i>
							供应商结算<br>
							已保存去提交
						</div>
						<div class="card" @click="supplierSettlement" v-if="orderData.status=='SUBMIT'">
							<i class="el-icon-folder-opened"></i>
							供应商结算<br>
							已提交去查看
						</div>
						<div class="card" @click="supplierSettlement" v-if="orderData.status=='SUCCESS'">
							<i class="el-icon-folder-checked"></i>
							供应商结算<br>
							审核通过去查看
						</div>
						<div class="card" @click="supplierSettlement" v-if="orderData.status=='ERROR'">
							<i class="el-icon-folder-delete"></i>
							供应商结算<br>
							审核驳回去修改
						</div>
						<div class="card" @click="supplierSettlement" v-if="orderData.status=='FINISH'">
							<i class="el-icon-tickets"></i>
							审核通过去查看
						</div>
						<div class="card" @click="settleAccountsShow = true" v-if="orderData.status=='ERROR'">
							<i class="el-icon-s-finance"></i>
							供应商结算<br>
							重新提交
						</div>
					</template>
				</div>
			</div>
			<div class="participationLink" label="参会链接" v-if="curNow=='5'">
				<!-- <p>{{MeetingDetail.codeUrl}}</p>
							<p>{{MeetingDetail.inviteCodeUrl}}</p>
							<p>{{MeetingDetail.liveUrl}}</p> -->
				<div class="row">
					<div class="col">
						<div class="qrcode">
							<h4>会议签到
								<span>点击二维码下载</span>
							</h4>
							<img :src="MeetingDetail.signCodeUrl" alt=""
								@click="downloadQrCode(MeetingDetail.signCodeUrl,'签到二维码')">
						</div>
					</div>

					<div class="col">
						<div class="qrcode">
							<h4>劳务签署
								<span>点击二维码下载</span>
							</h4>
							<img :src="MeetingDetail.inviteCodeUrl" alt=""
								@click="downloadQrCode(MeetingDetail.inviteCodeUrl,'劳务二维码')">
						</div>
					</div>

					<div class="col" v-if="MeetingDetail.meetingFormat!='OTHER'">
						<div class="qrcode">
							<h4>观看直播
								<span>点击二维码下载</span>
							</h4>
							<img :src="MeetingDetail.codeUrl" alt=""
								@click="downloadQrCode(MeetingDetail.codeUrl,'直播二维码')">
						</div>
						<div class="linkUrl" v-if="MeetingDetail.liveUrl">
							<h4>直播链接
							</h4>
							<a :href="MeetingDetail.liveUrl" target="_blank">{{MeetingDetail.liveUrl}}</a>
						</div>
					</div>

					<!-- <div class="col">
					<div class="qrcode">
						<h4>签到二维码（会前签到）</h4>
						<img :src="MeetingDetail.signCodeUrl" alt="">
					</div>
				</div> -->
				</div>
			</div>
			<div class="livePlayback" label="直播回放" v-if="curNow=='6'">
				<el-upload class="uploadVideo" :action="`${baseUrl}/sign/live/assistant/uploadMeetingVideo`"
					:data="{meetingId:$route.query.mId}" :headers="{'token':token}" :multiple="false"
					:file-list="videoList" :show-file-list="false" :on-success="videoSuccess"
					:before-upload="videoBeforeUpload">
					<el-button size="small" type="primary">上传直播回放</el-button>
				</el-upload>
				<!-- 手动上传的回放 -->
				<el-table :data="MeetingDetail.videos" key="videTable" style="width: 100%">
					<el-table-column prop="id" label="id" width="100" align="cneter"></el-table-column>
					<el-table-column label="名称" align="cneter">
						<template slot-scope="scope">
							【{{MeetingDetail.meetingTitle}}】
							会议录像 {{ scope.$index + 1 }}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="300" align="cneter">
						<template slot-scope="scope">
							<el-button size="mini" @click="viewVideo(scope.row)">查看</el-button>
							<el-button size="mini" @click="downloadVideo(scope.row)">下载</el-button>
							<el-button size="mini" @click="deleteVideo(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- TRTC 云端录制文件 -->
				<div v-if="trtcRecordings.length > 0" style="margin-top: 20px;">
					<h4 style="color: #409EFF; margin-bottom: 10px;"><i class="el-icon-video-camera"></i> TRTC 云端录制</h4>
					<el-table :data="trtcRecordings" key="trtcRecordTable" style="width: 100%">
						<el-table-column label="名称" min-width="200">
							<template slot-scope="scope">
								<span v-if="scope.row._editing !== true" style="cursor: pointer;" @dblclick="scope.row._editing = true">
									{{ scope.row._displayName || ('直播回放 ' + (scope.$index + 1)) }}
									<i class="el-icon-edit" style="margin-left: 6px; color: #409EFF; cursor: pointer;"
										@click="scope.row._editing = true"></i>
								</span>
								<el-input
									v-else
									v-model="scope.row._editName"
									size="mini"
									placeholder="输入名称"
									@keyup.enter.native="saveRecordingName(scope.row, scope.$index)"
									@blur="saveRecordingName(scope.row, scope.$index)">
								</el-input>
							</template>
						</el-table-column>
						<el-table-column label="时长" width="100" align="center">
							<template slot-scope="scope">
								{{ scope.row.duration ? Math.round(scope.row.duration / 60) + '分钟' : '-' }}
							</template>
						</el-table-column>
						<el-table-column label="大小" width="100" align="center">
							<template slot-scope="scope">
								{{ scope.row.fileSize ? (scope.row.fileSize / 1024 / 1024).toFixed(1) + 'MB' : '-' }}
							</template>
						</el-table-column>
						<el-table-column label="H5可见" width="80" align="center">
							<template slot-scope="scope">
								<el-switch
									v-model="scope.row.visible"
									:active-value="1"
									:inactive-value="0"
									@change="toggleRecordingVisible(scope.row)">
								</el-switch>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="250" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="primary" @click="viewVideo({videoPath: scope.row.fileUrl})"
									v-if="scope.row.fileUrl && !scope.row.fileUrl.startsWith('local://')">播放</el-button>
								<el-button size="mini" @click="downloadVideo({videoPath: scope.row.fileUrl})"
									v-if="scope.row.fileUrl && !scope.row.fileUrl.startsWith('local://')">下载</el-button>
								<el-button size="mini" type="danger" @click="deleteRecording(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 视频回放播放弹窗（独立于表格，确保 TRTC 录制和手动上传都能打开） -->
				<el-dialog custom-class="agreementDialog" v-if="viewVideoType" title="查看回放"
					:visible.sync="viewVideoType" width="1000px" :append-to-body="true">
					<video :src="showVideo" controls autoplay style="width: 100%;"></video>
				</el-dialog>
			</div>
			<!-- ==================== 截图浏览 Tab ==================== -->
			<div class="screenshotGallery" v-if="curNow=='8'">
				<div class="screenshot-header">
					<h3><i class="el-icon-picture-outline"></i> 会议截图浏览</h3>
					<el-button size="small" type="primary" icon="el-icon-camera" @click="manualCapture"
						:loading="capturingScreenshot">手动截图</el-button>
				</div>
				<div v-if="screenshotList.length === 0" class="empty-screenshots">
					<el-empty description="暂无截图记录">
						<el-button type="primary" size="small" @click="manualCapture">立即截图</el-button>
					</el-empty>
				</div>
				<div v-else class="screenshot-grid">
					<div class="screenshot-card" v-for="(item, i) in screenshotList" :key="item.id">
						<div class="screenshot-img-wrap">
							<el-image :src="resolveFileUrl(item.fileUrl)" fit="cover"
								:preview-src-list="screenshotList.map(s => resolveFileUrl(s.fileUrl))"
								class="screenshot-img">
								<div slot="placeholder" class="image-slot">
									加载中<span class="dot">...</span>
								</div>
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline" style="font-size: 40px; color: #ccc;"></i>
									<p style="font-size:12px; color:#999;">{{ item.fileName }}</p>
								</div>
							</el-image>
							<div class="screenshot-cover-badge" v-if="currentCoverUrl === item.fileUrl">
								<i class="el-icon-star-on"></i> 当前封面
							</div>
						</div>
						<div class="screenshot-info">
							<p class="screenshot-desc">{{ item.description || item.fileName }}</p>
							<p class="screenshot-time">{{ item.createTime ? $moment(item.createTime).format('MM-DD HH:mm:ss') : '' }}</p>
							<p class="screenshot-size" v-if="item.fileSize">{{ (item.fileSize / 1024).toFixed(0) }} KB</p>
						</div>
						<div class="screenshot-actions">
							<el-button size="mini" type="warning" icon="el-icon-star-off"
								@click="setAsCover(item)"
								:disabled="currentCoverUrl === item.fileUrl"
								v-if="item.fileUrl && !item.fileUrl.startsWith('local://')">
								{{ currentCoverUrl === item.fileUrl ? '已是封面' : '设为H5封面' }}
							</el-button>
							<el-button size="mini" icon="el-icon-download"
								@click="downloadScreenshot(item)"
								v-if="item.fileUrl && !item.fileUrl.startsWith('local://')">下载</el-button>
							<el-button size="mini" type="danger" icon="el-icon-delete"
								@click="deleteScreenshotItem(item)">删除</el-button>
						</div>
					</div>
				</div>
			</div>
			<!-- 合同签署 Tab -->
			<div class="contractSign" v-if="curNow=='7'" style="padding:16px">
				<meeting-sign-panel
					:meeting-id="meetingId"
					:project-id="MeetingDetail.projectId"
				/>
			</div>
			<div class="options">
				<el-button size="small" class="back" @click="back()">返回列表</el-button>
				<el-button size="small"
					v-if="(MeetingDetail.meetingStatus=='WAIT'||MeetingDetail.meetingStatus=='LIVING')&&MeetingDetail.meetingFormat!='OTHER'"
					type="primary" class="enter" @click.stop="enterTheMeeting()">进入会议</el-button>
				<!-- <el-button size="small" plain type="primary" class="back" @click="upMeetingFile()"
				v-if="(MeetingDetail.meetingStatus=='UPLOAD'||MeetingDetail.meetingStatus=='ERROR'||MeetingDetail.meetingStatus=='AI_REVIEW_ERROR'||MeetingDetail.meetingStatus=='OFFICIAL_ERROR')&&curNow==4">提交会后文件</el-button> -->
				<el-button size="small" plain type="primary" @click="ChangeMeetingDetail()"
					v-if="MeetingDetail.meetingStatus=='WAIT'">修改会议信息</el-button>
				<el-button size="small" plain type="danger" @click="ChangeMeetingDetail()"
					v-if="MeetingDetail.meetingStatus=='WAIT_CLAIM'">完善信息</el-button>
				<el-button size="small" plain type="warning" @click="delMeetingFun()"
					v-if="MeetingDetail.meetingStatus=='WAIT'&&MeetingDetail.createdId == userInfo.id">取消会议</el-button>
				<el-button size="small" plain type="danger" class="enter" @click.stop="closeTheMeeting()"
					v-if="MeetingDetail.meetingStatus=='WAIT'||(MeetingDetail.meetingStatus=='LIVING'&&MeetingDetail.meetingFormat!='ONLIEN')">结束会议</el-button>
			</div>
		</div>
		<!-- 项目进度 -->
		<el-dialog class="projectSchedule" v-if="projectSchedule" :visible.sync="projectSchedule" title="跟进项目进度"
			width="800px">
			<!-- 修改项目进度 -->
			<template>
				<el-table :data="MeetingDetail.logs" style="width: 100%">
					<el-table-column label="编辑日期" align="center" width="150px">>
						<template slot-scope="scope">
							<el-date-picker :disabled="scope.$index!==0&&!MeetingDetail.logs[scope.$index-1].updateTime"
								size="small" style="width: 100%;" v-model="scope.row.updateTime" type="date"
								placeholder="选择日期" value-format="timestamp">
							</el-date-picker>
						</template>
					</el-table-column>
					<el-table-column label="进度状态" align="center" width="120px">
						<template slot-scope="scope">
							<!-- <el-checkbox v-model="scope.row.statusVal">{{scope.row.status}}</el-checkbox> -->
							{{scope.row.status}}
						</template>
					</el-table-column>
					<el-table-column label="操作者" align="center" width="80px">
						<template slot-scope="scope">
							<span class="user">{{scope.row.actuatorFullName}}</span>
						</template>
					</el-table-column>
					<el-table-column label="备注" align="center">
						<template slot-scope="scope">
							<el-input :disabled="scope.$index!==0&& !MeetingDetail.logs[scope.$index-1].updateTime"
								clearable type="textarea" :rows="2" autosize placeholder="请输入备注："
								v-model="scope.row.message"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</template>
			<span slot="footer" class="dialog-footer">
				<el-button @click="projectSchedule = false">取 消</el-button>
				<el-button type="primary" @click="updateMeetingProgress">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 回款记录 -->
		<el-dialog v-if="paymentRecord" :visible.sync="paymentRecord" title="合同回款变更" width="800px">
			合同回款变更
			<span slot="footer" class="dialog-footer">
				<el-button @click="paymentRecord = false">取 消</el-button>
				<el-button type="primary" @click="paymentRecord = false">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 供应商结算 -->
		<el-dialog custom-class="settleAccounts" v-if="settleAccountsShow" :visible.sync="settleAccountsShow"
			title="请选择收款方式及费用类型" width="600px" center>
			<el-form ref="form" :model="accountForm" label-position="left">
				<el-row>
					<el-col :span="12">
						<el-form-item label="收款方式:">
							<el-select size="small" v-model="accountForm.collectWay" placeholder="请选择活动区域">
								<el-option v-for="(item,i) in collectWayEnums" :key="i" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="费用类型:">
							<el-select size="small" v-model="accountForm.feeType" placeholder="请选择活动区域">
								<el-option label="会议类" value="0"></el-option>
								<el-option label="非会议类" value="1" disabled></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="tips">
				<h3>请仔细阅读以下说明</h3>
				<p>如有 <b>一次性收款</b> ，直接选择“一次性收款并结项”</p>
				<p>如有 <b>两次收款</b> ，第一次选择“申请首次收款”，第二次选择“申请尾款”</p>
				<p>如有 <b>分三次及三次以上收款</b> ，第一次选择“申请首次收款”，中间付款选择“申请阶段收款”，最后一笔选择“申请尾款”</p>
				<p><b>据实结算</b> 的收款方式仅支持费用类型是会议类，框架服务模式，按场次收款的项目，可多次申请</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="supplierSettlement">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="`修改【${detailOfServicesRow.fullName}】关于【会议主题：${detailOfServicesRow.meetingTitle}】的劳务信息`"
			v-if="dlalogdetailOfServices" :visible.sync="dlalogdetailOfServices" width="500px"
			custom-class="changeDetailOfServices">
			<!-- {{detailOfServicesRow}} -->
			<el-form class="DetailOfServicesForm" ref="form" :model="detailOfServicesRow" label-position="top">
				<el-form-item label="姓名">
					<el-input v-model="detailOfServicesRow.fullName"></el-input>
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input v-model="detailOfServicesRow.cardId"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="detailOfServicesRow.phoneNumber"></el-input>
				</el-form-item>
				<el-form-item label="归属会议">
					<el-input v-model="detailOfServicesRow.meetingTitle"></el-input>
				</el-form-item>
				<el-form-item label="开户行">
					<el-input v-model="detailOfServicesRow.bankName"></el-input>
				</el-form-item>
				<el-form-item label="银行卡号">
					<el-input v-model="detailOfServicesRow.bankCardNumber"></el-input>
				</el-form-item>
				<el-form-item label="税前劳务金额">
					<el-input v-model.number="detailOfServicesRow.money" type="number"></el-input>
				</el-form-item>

				<el-form-item class="formFooter">
					<el-button @click="dlalogdetailOfServices = false">取消</el-button>
					<el-button type="primary" @click="changeDetail">确认修改</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		FormItem
	} from 'element-ui';
	import pdf from "vue-pdf";
	import {
		sendText,
		meetingOver,
		getMeetRoleList,
		getAgreementList,
		getUpdateMeetInfo,
		orderListAssistant,
		getMeetingUrl,
		uploadMeetingFile,
		getMeetingFile,
		delMeetingFile,
		delMeeting,
		getOrgList,
		getMechanismList,
		getEnterPriseList,
		getAssistantUserList,
		updateMeetingStatus,
		getCollectWay,
		getOrderByMeetId,
		delMeetingVideo,
		getAssistantInfo,
		getImportOrderById,
		editImportOrderMessage,
		delImportOrder,
		meetUserInfoList,
		getScreenshots,
		getRecordings,
		captureScreenshot,
		setScreenshotAsCover,
		deleteScreenshot,
		deleteRecordingEvidence,
		toggleRecordingVisibility,
		renameRecordingEvidence,
	} from '@/request/api.js';
	import baseUrl from "@/request/config.js"
	export default {
		name: 'meetdetails',
		data() {
			return {
				loading: false,
				detailOfServicesRow: '',
				dlalogdetailOfServices: false,
				loadingText: '',
				baseUrl: '',
				curNow: "3",
				list: [{
						name: '会议详情',
						class: '3',
					},
					{
						name: '会议医生信息',
						class: '1',
					},
					{
						name: '劳务明细',
						class: '2',
					},
					{
						name: '合同签署',
						class: '7',
					},
					{
						name: '直播回放',
						class: '6',
					},
					{
						name: '截图浏览',
						class: '8',
					},
					{
						name: '会议链接',
						class: '5',
					},
					{
						name: '会后结算',
						class: '4',
					}
				],
				list2: [{
						name: '会议详情',
						class: '3',
					},
					{
						name: '会议医生信息',
						class: '1',
					},
					{
						name: '劳务明细',
						class: '2',
					},
					{
						name: '合同签署',
						class: '7',
					},
					{
						name: '截图浏览',
						class: '8',
					},
					{
						name: '会议链接',
						class: '5',
					}
				],
				srcList: [],
				meetingId: '',
				activeName: '1',
				MeetingDetail: '',
				userInfo: '',
				agreementList: [],
				orderList: '', // 费用明细
				roleList: '',
				certificateList: [], // 四证列表
				template: '',
				meetStatus: '',
				dialogVisible: false,
				dialogFileUrl: {},
				viewVideoType: false, // 查看视频回放
				showVideo: '',
				annotation: {
					file1: '会议通知',
					file2: '会议日程',
					file3: '会议照片',
					file4: '签到表',
					file5: '劳务协议',
					file6: '劳务协议明细表',
				},
				MechanismList: [], // 立项单位列表
				projectOriginator: '',
				orgList: [], // 执行机构列表
				orgListUser: [], // 执行机构人员列表
				executive: '',
				enterPriseList: [], // 支持企业列表
				supportStaff: '',
				projectSchedule: false, // 项目进度
				paymentRecord: false, // 回款记录
				errorMsg: {},
				currentPage: 1, // 当前页码
				numPages: 0, // 设置总页码
				settleAccountsShow: false, // 结算记录
				accountForm: {
					feeType: '0',
					collectWay: ""
				},
				collectWayEnums: [],
				orderData: '',
				token: '',
				videoList: [],
				userList: '',
				// ===== 截图浏览 =====
				screenshotList: [],         // 截图列表
				trtcRecordings: [],         // TRTC 录制文件列表
				capturingScreenshot: false, // 手动截图加载中
				currentCoverUrl: '',        // 当前 H5 封面 URL
			}
		},
		components: {
			pdf,
			MeetingSignPanel: () => import('@/components/MeetingSignPanel.vue')
		},
		created() {
			this.baseUrl = baseUrl;
			this.meetStatus = this.$route.query.status;
			this.meetingId = this.$route.query.mId;
			this.curNow = this.$route.query.now;

			this.getOrgListFun();
			this.getCollectWayFun();
			this.token = JSON.parse(localStorage.getItem('token')).token
			this.getAssistantInfoFun()
			this.getmeetingUserInfoListFun();
		},
		mounted() {
			this.getMeetInfo();
			this.getMeetFile();
		},
		methods: {

			changeDetailShowDlog(row) {
				getImportOrderById({
					id: row.id
				}).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.detailOfServicesRow = res.data;
						this.dlalogdetailOfServices = true;
					}
				})
			},
			changeDetail() {
				editImportOrderMessage(this.detailOfServicesRow).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.dlalogdetailOfServices = false;
						this.getorderListAssistantFun()
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				})
			},

			getAssistantInfoFun() {
				getAssistantInfo().then(res => {
					// console.log(res);
					this.userInfo = res.data;
				})
			},

			// // 查看四证信息
			// viewCertificate(row) {
			// 	// console.log(row.id);
			// 	getUserFileList({
			// 		userId: row.id
			// 	}).then(res => {
			// 		this.certificateList = res.data.map(item => item.filePath)
			// 		this.certificateShow = true;
			// 	})
			// },

			async downloadQrCode(url, name) {

				// console.log(url, name)
				// 下载图片
				let a = document.createElement('a')
				a.href = url
				a.download = name
				a.click(); // 自动触发点击事件下载文件

			},

			deleteVideo(row) {
				console.log(row);
				// 确认弹窗
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delMeetingVideo({
						id: row.id
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getMeetInfo();
						} else {
							this.$message.error(res.msg);
						}
					})
				})
			},
			downloadVideo(row) {
				window.open(row.videoPath)
			},
			// 查看视频回放
			viewVideo(row) {
				this.viewVideoType = true;
				this.showVideo = row.videoPath;
			},
			// 去上传会后文件
			uploadPostMeetingDocuments() {
				this.$router.push({
					name: 'uploadFile',
					query: {
						mId: this.meetingId
					}
				})
			},
			getCollectWayFun() {
				getCollectWay({
					projectId: this.projectId,
					meetingId: this.meetingId,
					type: 'meeting'
				}).then(res => {
					if (res.code == 200) {
						console.log(res.data)
						this.collectWayEnums = res.data;
						if (this.collectWayEnums.length == 1) {
							this.accountForm.collectWay = this.collectWayEnums[0].value;
						}
					};
				});
			},
			// 跳转供应商结算页面
			supplierSettlement() {
				this.$router.push({
					name: 'supplierSettlement',
					query: {
						mId: this.meetingId,
						collectWay: this.accountForm.collectWay,
						feeType: this.accountForm.feeType
					}
				})
			},
			// 更新会议进度
			updateMeetingProgress() {
				let data = JSON.parse(JSON.stringify(this.MeetingDetail.logs));
				for (let i = data.length - 1; i >= 0; i--) {
					if (!data[i].updateTime && !data[i].message) {
						data.splice(i, 1);
					};
				};
				updateMeetingStatus(data).then(res => {
					if (res.code == 200) {
						this.projectSchedule = false;
						// this.getMeetInfo();
					};
				});
			},
			// 删除会议
			delMeetingFun() {
				this.$confirm(`此操作删除会议【${this.MeetingDetail.meetingTitle}】, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true;
					this.loadingText = "正在删除···";
					let data = {
						id: this.meetingId
					};
					delMeeting(data).then(res => {
						this.loading = false;
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});

							let projectId = JSON.parse(localStorage.getItem('projectDetails')).id;
							this.$router.push({
								name: 'meetinglist',
								query: {
									pId: projectId
								}
							});
						}
					}).catch(err => {
						this.loading = false;
					})
				});
			},
			// 会后上传文件回显
			getMeetFile() {
				// getMeetingFile({
				// 	meetingId: this.meetingId
				// }).then(res => {
				// 	// console.log(res.data)
				// 	for (let key in res.data.values) {
				// 		this[key] = res.data.values[key].map((item, i) => {
				// 			// console.log(item);
				// 			// console.log(res.data.fileNames[key][i])
				// 			return {
				// 				url: item,
				// 				name: res.data.fileNames[key][i]
				// 			}
				// 		})
				// 		this.errorMsg[key] = res.data.errorMessages[key] ? res.data.errorMessages[key].split(
				// 			'\n') : null;
				// 	}
				// })
			},
			// 上传会后文件
			upMeetingFile() {
				let data = {
					files: {
						file1: this.file1,
						file2: this.file2,
						file3: this.file3,
						file4: this.file4,
						file5: this.file5,
						file6: this.file6
					},
					applyMoney: this.MeetingDetail.applyMoney,
					names: {},
					// joinNums: this.model.peopleNum,
					meetingId: this.meetingId,
					annotation: this.annotation
				};
				for (let i in data.files) {
					data.names[i] = data.files[i].map((item) => {
						return {
							'key': item.response,
							"value": item.name
						}
					});
					data.files[i] = data.files[i].map(item => item.response ? item.response : item.url);
				};
				this.loading = true;
				uploadMeetingFile(data).then(res => {
					this.loading = false;
					if (res.code == 200) {
						// console.log(res);
						this.$router.push({
							name: 'meetinglist',
							query: {
								pId: this.MeetingDetail.projectId
							}
						})
						this.$notify({
							title: '上传成功',
							type: 'success',
							message: '上传成功',
							position: 'bottom-right'
						});
					}
				})
			},
			videoBeforeUpload(file) {
				this.loading = true;
				this.loadingText = '正在上传中 请不要进行其他操作 稍等片刻···'
			},
			videoSuccess(res, file) {
				// this.videoUrl = res.data;
				this.loading = false;
				this.$message({
					message: `文件 ${file.name} 上传成功。`,
					type: 'success'
				});
				this.getMeetInfo();
			},

			// 删除一条明细
			deleteDetail(row) {
				// 删除前二次确认
				this.$confirm('此操作将永久删除该条明细, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						console.log(JSON.parse(JSON.stringify(row)))
						delImportOrder({
							id: row.id
						}).then(res => {
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.getorderListAssistantFun()
							} else {
								this.$message({
									type: 'error',
									message: res.msg
								});
							}
						})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			},

			getmeetingUserInfoListFun() {
				//获取会议人员列表
				meetUserInfoList({
					meetingId: this.$route.query.mId
				}).then(res => {
					if (res.code == 200) {
						this.userList = res.data;
					}
				})
			},

			// 文件上传中
			onProgress(event, file, fileList) {
				this.loading = true;
				if (event.percent < 100) {
					this.loadingText = `文件上传中···，当前${event.percent.toFixed(2)}%`;
				} else {
					this.loadingText = '文件上传成功，服务器正在处理···';
				}
			},

			File6Success(res, file) {
				// console.log(res)
				// console.log(file.name)
				this.loading = false;
				if (res.code == 200) {
					this.getorderListAssistantFun()
					this.$message({
						message: `文件 ${file.name} 上传成功。${res.data.msg}`,
						type: 'success'
					});
				} else {
					this.$message({
						message: `${res.msg}`,
						type: 'error'
					});
				}
			},
			// handSuccess1(res, file) {
			// 	this.file1.push(file);
			// 	this.$message({
			// 		message: `文件 ${file.name} 上传成功。`,
			// 		type: 'success'
			// 	});
			// },
			// handSuccess2(res, file) {
			// 	this.file2.push(file);
			// 	this.$message({
			// 		message: `文件 ${file.name} 上传成功。`,
			// 		type: 'success'
			// 	});
			// },
			// handSuccess3(res, file) {
			// 	this.file3.push(file);
			// 	this.$message({
			// 		message: `文件 ${file.name} 上传成功。`,
			// 		type: 'success'
			// 	});
			// },
			// handSuccess4(res, file) {
			// 	this.file4.push(file);
			// 	this.$message({
			// 		message: `文件 ${file.name} 上传成功。`,
			// 		type: 'success'
			// 	});
			// },
			// handSuccess5(res, file) {
			// 	this.file5.push(file);
			// 	this.$message({
			// 		message: `文件 ${file.name} 上传成功。`,
			// 		type: 'success'
			// 	});
			// },
			// handSuccess6(res, file) {
			// 	this.file6.push(file);
			// 	this.$message({
			// 		message: `文件 ${file.name} 上传成功。`,
			// 		type: 'success'
			// 	});
			// },
			// 删除上传的内容
			deletePic(file, idx, key) {
				//删除前确认
				this.$confirm(`此操作将永久删除该文件, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (file.url) {
						delMeetingFile({
							filePath: file.url
						}).then(res => {
							if (res.code == 200) {
								console.log(res.data);
								this[key].splice(idx, 1);
							}
						})
					} else {
						this[key].splice(idx, 1);
					}
				})
			},
			isImage(filename) {
				let extension = '';
				// 判断一个字符串中是否包含“?”字符
				if (filename.includes('?')) {
					extension = filename.split('?')[0].split('.').pop().toLowerCase();
				} else {
					extension = filename.split('.').pop().toLowerCase();
				}
				const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
				return imageExtensions.includes(extension);
			},
			isFile(filename) {
				let extension = '';
				// 判断一个字符串中是否包含“?”字符
				if (filename.includes('?')) {
					extension = filename.split('?')[0].split('.').pop().toLowerCase();
				} else {
					extension = filename.split('.').pop().toLowerCase();
				}
				const imageExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
				return imageExtensions.includes(extension);
			},
			// handlePreview(file) {
			// 	if (file.url) {
			// 		this.dialogFileUrl = {
			// 			url: file.url,
			// 		};
			// 		if (this.isImage(file.name)) {
			// 			this.dialogFileUrl.type = 'image';
			// 		} else if (this.isFile(file.name)) {
			// 			this.dialogFileUrl.type = 'file';
			// 		} else {
			// 			this.dialogFileUrl.type = 'pdf';
			// 		}
			// 		this.dialogVisible = true;
			// 	} else {
			// 		this.$message.error(`文件 ${file.name} 为同步到服务器，请先确认提交。`);
			// 	}
			// },
			tabsChange(item) {
				this.curNow = item.class;
				// 切换到截图浏览时加载截图列表
				if (item.class === '8') {
					this.loadScreenshots();
				}
				// 切换到直播回放时加载TRTC录制文件
				if (item.class === '6') {
					this.loadRecordings();
				}
			},
			// 结束会议
			closeTheMeeting() {
				let data = {
					meetingId: this.meetingId
				}
				this.$confirm('此操作将会结束当前的会议, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true;
					this.loadingText = '加载中···'
					meetingOver(data).then(res => {
						this.loading = false;
						if (res.code == 200) {
							// this.$router.push({
							// 	name: 'meetinglist',
							// 	query: {
							// 		pId: this.MeetingDetail.projectId
							// 	}
							// })
							this.getMeetInfo();
							this.$forceUpdate();
							this.$message({
								type: 'info',
								message: '会议已结束!'
							});
							this.$notify({
								type: 'info',
								title: '提示',
								message: '会议已结束!',
								position: 'bottom-right'
							});
						}
					}).catch(err => {
						this.loading = false;
					})
				});

			},
			// 进入会议
			enterTheMeeting() {
				if (this.MeetingDetail.meetingLiveUrl) {
					window.open(this.MeetingDetail.meetingLiveUrl);
				} else {
					let data = {
						meetingId: this.meetingId
					}
					getMeetingUrl(data).then(res => {
						if (res.code == 200) {
							window.open(res.data)
						} else {
							this.getMeetInfo();
							this.$message({
								message: res.msg,
								type: 'error'
							});
							this.$notify({
								type: 'error',
								title: '错误',
								message: res.msg,
								position: 'bottom-right'
							});
						}
					})
				}
			},

			// ==================== 截图浏览相关方法 ====================

			// 加载截图列表
			loadScreenshots() {
				getScreenshots(this.meetingId).then(res => {
					if (res.code == 200) {
						let list = res.data || [];
						list.forEach(item => {
							item.fileUrl = this.parseImageUrl(item.fileUrl);
						});
						this.screenshotList = list;
					}
				}).catch(() => {
					this.screenshotList = [];
				});
				// 读取当前封面 URL
				if (this.MeetingDetail && this.MeetingDetail.coverImageUrl) {
					this.currentCoverUrl = this.MeetingDetail.coverImageUrl;
				}
			},

			// 加载 TRTC 云端录制文件列表
			loadRecordings() {
				getRecordings(this.meetingId).then(res => {
					if (res.code == 200) {
						// 兼容历史数据：visible 为 null 时默认设为 1（可见）
						let list = res.data || [];
						list.forEach((item, idx) => {
							if (item.visible === null || item.visible === undefined) {
								item.visible = 1;
							}
							var rawName = item.fileName || '';
							var isDefault = rawName.startsWith('云端录制_') || rawName === '';
							item._displayName = isDefault ? '' : rawName;
							item._editName = item._displayName || ('直播回放 ' + (idx + 1));
							item._editing = false;
						});
						this.trtcRecordings = list;
					}
				}).catch(() => {
					this.trtcRecordings = [];
				});
			},

			// 删除录制记录
			deleteRecording(row) {
				this.$confirm('确定要删除该录制记录吗？删除后不可恢复。', '提示', {
					confirmButtonText: '确定删除',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteRecordingEvidence(row.id).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.loadRecordings();
						} else {
							this.$message.error(res.msg || '删除失败');
						}
					}).catch(() => {
						this.$message.error('删除失败');
					});
				}).catch(() => {});
			},

			// 切换录制文件 H5 可见性
			toggleRecordingVisible(row) {
				toggleRecordingVisibility(row.id, row.visible).then(res => {
					if (res.code == 200) {
						this.$message.success(row.visible == 1 ? '已设为H5可见' : '已设为H5隐藏');
					} else {
						this.$message.error(res.msg || '操作失败');
						// 恢复原值
						row.visible = row.visible == 1 ? 0 : 1;
					}
				}).catch(() => {
					this.$message.error('操作失败');
					row.visible = row.visible == 1 ? 0 : 1;
				});
			},

			// 保存录制文件的自定义名称
			saveRecordingName(row, index) {
				const newName = (row._editName || '').trim();
				if (!newName) {
					// 空名称取消编辑
					this.$set(row, '_editing', false);
					return;
				}
				renameRecordingEvidence(row.id, newName).then(res => {
					if (res.code == 200) {
						this.$set(row, '_displayName', newName);
						this.$set(row, 'fileName', newName);
						this.$set(row, '_editing', false);
						this.$message.success('重命名成功');
					} else {
						this.$message.error(res.msg || '重命名失败');
					}
				}).catch(() => {
					this.$message.error('重命名失败');
				});
			},

			// 手动触发一次截图
			manualCapture() {
				this.capturingScreenshot = true;
				captureScreenshot(this.meetingId).then(res => {
					this.capturingScreenshot = false;
					if (res.code == 200) {
						this.$message.success('截图成功！');
						this.loadScreenshots(); // 刷新列表
					} else {
						this.$message.error(res.msg || '截图失败');
					}
				}).catch(() => {
					this.capturingScreenshot = false;
					this.$message.error('截图请求失败');
				});
			},

			// 设置截图为 H5 封面
			setAsCover(item) {
				this.$confirm(`确认将此截图设为 H5 直播间封面？`, '设置封面', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					setScreenshotAsCover(this.meetingId, item.fileUrl).then(res => {
						if (res.code == 200) {
							this.currentCoverUrl = item.fileUrl;
							this.$message.success('封面设置成功！');
						} else {
							this.$message.error(res.msg || '设置失败');
						}
					});
				}).catch(() => {});
			},

			// 下载截图
			downloadScreenshot(item) {
				let url = this.parseImageUrl(item.fileUrl);
				if (!url) {
					this.$message.error('无法获取截图地址');
					return;
				}
				
				this.$message.info('正在获取图片，如未直接下载，请在新弹出的页面右键选择【图片另存为】。');
				const a = document.createElement('a');
				a.href = url;
				a.target = '_blank';
				a.download = item.fileName || 'screenshot.png';
				document.body.appendChild(a);
				a.click();
				setTimeout(() => {
					document.body.removeChild(a);
				}, 2000);
			},

			/** 智能解析图片URL，防止 JSON 字符串直接渲染 */
			parseImageUrl(val) {
				if (!val) return '';
				if (typeof val === 'string' && val.trim().startsWith('[')) {
					try {
						let arr = JSON.parse(val);
						if (arr && arr.length > 0) {
							return arr[0].url || arr[0].response || arr[0];
						}
					} catch (e) {}
				}
				if (typeof val === 'string' && val.trim().startsWith('{')) {
					try {
						let obj = JSON.parse(val);
						return obj.url || obj.response || val;
					} catch (e) {}
				}
				return val;
			},

			/** 解析文件URL：对本地路径补全后端地址 */
			resolveFileUrl(url) {
				if (!url) return '';
				// 如果是 /local-files/ 开头的本地路径，拼接后端 baseUrl
				if (url.startsWith('/local-files/')) {
					return this.baseUrl + url;
				}
				// 如果是 local:// 协议（旧数据），不可访问，返回空
				if (url.startsWith('local://')) {
					return '';
				}
				return url;
			},
			// 下载截图
			downloadScreenshot(item) {
				if (!item.fileUrl) return;
				const url = this.resolveFileUrl(item.fileUrl);
				fetch(url, { mode: 'cors' }).then(res => res.blob()).then(blob => {
					let blobUrl = window.URL.createObjectURL(blob);
					let a = document.createElement('a');
					a.style.display = 'none';
					a.href = blobUrl;
					a.download = item.fileName || '截图';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					window.URL.revokeObjectURL(blobUrl);
				}).catch(() => {
					// 降级方案：如果有跨域拦截，回退到原来的新标签页打开
					let a = document.createElement('a');
					a.href = url;
					a.download = item.fileName || '截图';
					a.target = '_blank';
					a.click();
				});
			},

			/** 删除截图 */
			deleteScreenshotItem(item) {
				this.$confirm('确认删除此截图？删除后不可恢复。', '提示', {
					confirmButtonText: '确定删除',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteScreenshot(item.id).then(res => {
						if (res && res.code === 200) {
							this.$message.success('截图已删除');
							// 从列表中移除
							const idx = this.screenshotList.findIndex(s => s.id === item.id);
							if (idx > -1) {
								this.screenshotList.splice(idx, 1);
							}
							// 如果删除的是封面图，清空封面
							if (this.currentCoverUrl === item.fileUrl) {
								this.currentCoverUrl = '';
							}
						} else {
							this.$message.error((res && res.msg) || '删除失败');
						}
					}).catch(() => {
						// 如果后端接口还没实现，前端先直接移除
						const idx = this.screenshotList.findIndex(s => s.id === item.id);
						if (idx > -1) {
							this.screenshotList.splice(idx, 1);
							this.$message.success('截图已移除');
						}
					});
				}).catch(() => {});
			},
			// 修改会议信息
			ChangeMeetingDetail() {
				// console.log(JSON.parse(JSON.stringify(this.MeetingDetail)))
				// let projectId = JSON.parse(localStorage.getItem('projectDetails')).id;
				this.$router.push({
					name: 'createmeet',
					query: {
						// pId: projectId,
						mId: this.meetingId
					}
				})
			},
			// 发送提醒签协议短信
			sendTextFun(item) {
				let data = {
					ids: [item.id]
				};
				sendText(data).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.$notify({
							type: 'success',
							title: '发送成功',
							message: res.msg,
							position: 'bottom-right'
						});
						this.getAgreementListFun();
					};
				})
			},
			getOrgListFun() {
				//获取立项单位列表
				getMechanismList().then(res => {
					if (res.code == 200) {
						this.MechanismList = res.data;
					}
				}).catch(e => {
					console.warn('[会议详情] 获取立项单位列表失败:', e);
					this.MechanismList = [];
				})
				// 获取支持企业列表
				getEnterPriseList().then(res => {
					if (res.code == 200) {
						this.enterPriseList = res.data;
					}
				}).catch(e => {
					console.warn('[会议详情] 获取支持企业列表失败:', e);
					this.enterPriseList = [];
				})
				// 获取执行机构列表
				getOrgList().then(res => {
					if (res.code == 200) {
						this.orgList = res.data
					}
				}).catch(e => {
					console.warn('[会议详情] 获取执行机构列表失败:', e);
					this.orgList = [];
				})
			},


			// 获取会议信息
			getMeetInfo() {
				let data = {
					meetingId: this.meetingId
				}
				getUpdateMeetInfo(data).then(res => {
					if (res.code == 200) {
						// 智能解析图片字段，防止因为历史原因包含了 JSON 字符串
						res.data.coverImageUrl = this.parseImageUrl(res.data.coverImageUrl);
						res.data.bgImage = this.parseImageUrl(res.data.bgImage);
						res.data.bill = this.parseImageUrl(res.data.bill);

						this.MeetingDetail = res.data
						this.srcList = [];
						this.srcList.push(res.data.bgImage);
						this.srcList.push(res.data.bill);
						this.srcList.push(res.data.coverImageUrl);
						let data = {};
						let data2 = {};
						let data3 = {};
						if (Array.isArray(this.MechanismList)) { this.MechanismList.forEach(item => {
						if (item.id == this.MeetingDetail.meetingMechanismId) {
							this.MechanismList = item;
						}
					}); }
						this.enterPriseList.map(item => {
							if (item.id == this.MeetingDetail.meetingEnterpriseId) {
								this.enterPriseList = item;
							};
						});
						this.orgList.map(item => {
							if (item.id == this.MeetingDetail.meetingActuatorId) {
								this.orgList = item;
							};
						});
						// 助教列表
						data.actuatorId = this.MeetingDetail.meetingActuatorId;
						getAssistantUserList(data).then(res => {
							if (res.code == 200) {
								// console.log("助教")
								// console.log(res.data)
								this.orgListUser = res.data
								// let arr = [];
								// this.MeetingDetail.actuatorIds.map(itemId => {
								// 	res.data.map(item => {
								// 		if (item.id == itemId) arr.push(item);
								// 	});
								// });
								// this.MeetingDetail.actuatorIds = arr.map(item => item.fullName);
							};
						});
						// 官员列表
						data3.mechanismId = this.MeetingDetail.meetingMechanismId;
						getAssistantUserList(data3).then(res => {
							if (res.code == 200) {
								this.executive = res.data;
								let arr = [];
								this.MeetingDetail.fundraisingIds.map(itemId => {
									res.data.map(item => {
										if (item.id == itemId) arr.push(item);
									});
								});
								// this.MeetingDetail.fundraisingIds = arr.map(item => item.fullName);
								// let arr2 = [];
								// this.MeetingDetail.officesIds.map(itemId => {
								// 	res.data.map(item => {
								// 		if (item.id == itemId) arr2.push(item);
								// 	});
								// });
								// this.MeetingDetail.officesIds = arr2.map(item => item.fullName);
							}
						})
						getMeetRoleList({
							meetingId: this.MeetingDetail.id
						}).then(res => {
							if (res.code == 200) {
								let roleData = {};
								res.data.map(item => {
									roleData[item.id] = item.roleName
								})
								this.roleList = roleData;
							}
						})
					}
				})
				this.getOrderByMeetIdFun();
				this.getorderListAssistantFun(data);
				this.getAgreementListFun();
			},

			getorderListAssistantFun() {
				orderListAssistant({
					meetingId: this.meetingId
				}).then(res => {
					if (res.code == 200) {
						this.orderList = res.data;
						this.$forceUpdate()
					}
				})
			},
			getOrderByMeetIdFun() {
				getOrderByMeetId({
					meetingId: this.$route.query.mId,
				}).then(res => {
					if (res.code == 200) {
						this.orderData = res.data;
						this.$forceUpdate()
					}
				})
			},
			getAgreementListFun() {
				let data = {
					meetingId: this.meetingId
				}
				getAgreementList(data).then(res => {
					// console.log(res)
					if (res.code == 200) {
						this.agreementList = res.data;
					}
				})
			},
			signAnAgreement() {
				this.$router.push({
					name: 'agreement'
				});
			},
			// 获取页码总数
			handleNumPages(numPages) {
				this.numPages = numPages;
			},
			// 点击之后页面切换为上一页
			previousPages() {
				this.currentPage--;
			},
			// 点击之后页面切换为上一页
			nextPages() {
				this.currentPage++
			},
			back() {
				// 入口判断: 从"我的会议"进来的, 返回"我的会议", 并把原来停留的页码带回去
				if (this.$route.query?.from === 'myMeetings') {
					const fromPage = this.$route.query.fromPage;
					this.$router.push({
						name: 'myMeetings',
						query: fromPage ? { page: fromPage } : {}
					});
					return;
				}
				this.$router.push({
					name: 'meetinglist',
					query: {
						pId: this.MeetingDetail.projectId
					}
				});
			},

			/** 会议日期范围: 起止相同只显示一次, 否则显示 "start ~ end" */
			formatMeetingDateRange(start, end) {
				if (!start) return '-';
				const s = this.$moment(start).format('YYYY-MM-DD HH:mm');
				if (!end) return s;
				const e = this.$moment(end).format('YYYY-MM-DD HH:mm');
				return s === e ? s : `${s} ~ ${e}`;
			},

			/** 会议状态中文映射 (同时覆盖新枚举 MeetingPhase 和老状态码) */
			meetingStatusLabel(status) {
				const map = {
					// 新: MeetingPhase 枚举
					PENDING_CLAIM: '待认领', PREPARING: '待开始', EXECUTING: '进行中',
					COLLECTING: '归档期', AI_AUDITING: 'AI 审核中', MANUAL_AUDITING: '官员审核中',
					SIGNING: '签署中', SETTLING: '结算中', PAYMENT: '打款中',
					COMPLETED: '已完成', REJECTED: '已驳回',
					// 旧: 老状态码
					WAIT: '待开始', WAIT_CLAIM: '待认领', LIVING: '进行中',
					FINISH: '已结束', UPLOAD: '待上传',
					AI_REVIEW: 'AI 审核中', AI_REVIEW_ERROR: 'AI 驳回',
					AI_REVIEW_SUCCESS: 'AI 通过', AI_REVIEW_ERROR_ACCEPT: '官员复核中',
					OFFICIAL_SUCCESS: '官员通过', OFFICIAL_ERROR: '官员驳回',
					SUCCESS: '审核通过', ERROR: '财务驳回'
				};
				return map[status] || status || '-';
			},
			meetingStatusTagType(status) {
				// 进行中
				if (['LIVING', 'EXECUTING'].includes(status)) return 'warning';
				// 完成/通过
				if (['SUCCESS', 'FINISH', 'COMPLETED', 'OFFICIAL_SUCCESS', 'AI_REVIEW_SUCCESS'].includes(status)) return 'success';
				// 驳回
				if (['AI_REVIEW_ERROR', 'OFFICIAL_ERROR', 'ERROR', 'REJECTED'].includes(status)) return 'danger';
				// 处理中
				if (['UPLOAD', 'AI_REVIEW', 'AI_REVIEW_ERROR_ACCEPT',
					'COLLECTING', 'AI_AUDITING', 'MANUAL_AUDITING', 'SIGNING', 'SETTLING', 'PAYMENT'].includes(status)) return '';
				return 'info'; // WAIT / WAIT_CLAIM / PENDING_CLAIM / PREPARING / 未知
			}
		}
	}
</script>

<style lang="scss" scoped>
	#meetdetails {
		padding: 16px;
		min-height: 100%;
		background: #f4f6f9;   /* 页面底色, 让白色卡片之间有视觉分隔 */

		/* .top 自身只做布局容器, 不画卡片 — 内部 .title 与 .tabs 各自是独立卡片 */
		.top {
			padding: 0;
			margin-bottom: 0;
			background: transparent;
			border: none;
			box-shadow: none;
		}

		>.el-alert {
			margin-bottom: 12px;
		}

		/* 卡片 1: 会议主题 (独立) */
		.title {
			font-size: 16px;
			font-weight: 600;
			color: #1a1a2e;
			padding: 14px 20px 14px 36px;
			margin-bottom: 12px;
			position: relative;
			background: #fff;
			border: 1px solid #eef0f6;
			border-radius: 8px;

			i {
				top: 50%;
				left: 18px;
				width: 12px;
				height: 12px;
				position: absolute;
				border-radius: 50%;
				background-color: #3563E9;
				border: 3px solid #C2D0F8;
				transform: translateY(-50%);
			}
		}

		/* 卡片 2: Tab 导航 + 下方内容 (视觉上一体) */
		.tabs {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-around;
			background: #fff;
			border: 1px solid #eef0f6;
			border-bottom: none;             /* 与下方内容连成一张卡 */
			border-radius: 8px 8px 0 0;
			padding: 0 8px;

			.el-divider {
				width: 1px;
				height: 16px;
				margin: 0;
			}

			p {
				width: 100%;
				padding: 10px 5px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				cursor: pointer;
				line-height: 2.5;
				position: relative;

				i {
					width: 100%;
					left: 0;
					bottom: 0;
					height: 0;
					background-color: #0065FF;
					position: absolute;
					transition: all .3s;
				}

				span {
					margin-left: 10px;
					height: 26px;
					width: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 12px;
					background-color: #007AFF;
					border-radius: 5px;
					color: #fff;
				}

				b {
					font-weight: normal;
				}

				.tab4 {
					font-weight: bold;
					color: #0065ff;
				}
			}

			.active {
				color: #007AFF;

				i {
					height: 6px;
				}
			}
		}


		.el-tabs__item {
			font-size: 16px;
		}

		.el-tab-pane {
			overflow: hidden;
		}

		/* 所有 tab 内容区: 紧贴在 .tabs 之下, 视觉上和 tabs 同一张卡片 */
		.laborProgress,
		.conferenceReplay,
		.meetingDetails,
		.participationLink,
		.postMeetingUpload,
		.livePlayback {
			background: #fff;
			border: 1px solid #eef0f6;
			border-top: none;
			border-radius: 0 0 8px 8px;
			padding: 14px 16px;
			margin-bottom: 12px;
		}

		.laborProgress {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			/* 内部 lpBox 不再独立卡片化 (已被外层 .laborProgress 卡片化) */
			.lpBox {
				width: 100%;
				padding: 0;
				background: transparent;
				border: none;
				box-shadow: none;
			}

			.el-row {
				padding: 10px 0;
				margin-bottom: 20px;
			}

			.tabTitle {
				border-bottom: 2px solid #eee;
				width: 100%;

				* {
					font-size: 16px;
				}

				.el-col {
					text-align: center;
					border-right: 1px solid #ccc;

					&:last-child {
						border-right: none;
					}
				}
			}

			.tabContent {
				border-radius: 10px;
				box-shadow: 0px 2px 13px rgba(203, 203, 203, 0.31);
				width: 100%;

				* {
					font-size: 15px;
				}

				.el-col {
					padding: 10px 20px;
					text-align: center;
				}

				.preTax {
					padding: 5px 20px;
					border-radius: 20px;
					background-color: #F1F6FC;
					box-shadow: 0 0 14px rgba(0, 0, 0, 0.1);
				}

				.afterTax {
					padding: 5px 20px;
					border-radius: 20px;
					background-color: #F1FCF5;
					box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
				}
			}

			.endNode {
				border-radius: 10px;
				width: 100%;
				margin: 0;

				* {
					font-size: 16px;
					color: #0068FF;
				}

				.el-col {
					padding: 10px 20px;
				}

				.preAmount {
					font-size: 20px;
				}

				.amount {
					font-size: 20px;
				}
			}

		}

		.meetingDetails {
			display: flex;
			flex-direction: row;
			gap: 12px;

			.el-row {
				margin: 0 0 6px;
			}

			/* label + value 同行布局 */
			.el-col {
				display: flex;
				align-items: flex-start;
				overflow: hidden;

				>p {
					flex-shrink: 0;
					width: 88px;
					margin: 0;
					padding: 6px 0;
					font-size: 13px;
					font-weight: 500;
					color: #6b7280;
					line-height: 1.5;
				}

				>div {
					flex: 1;
					min-width: 0;
					margin: 0;
					padding: 6px 10px;
					border-radius: 4px;
					font-size: 13px;
					color: #1f2937;
					line-height: 1.5;
					word-break: break-all;
				}
			}

			::v-deep .el-image {
				width: 100%;
				max-width: 280px;
				height: 180px;
				border-radius: 6px;
				box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
			}

			/* 三列扁平排版 — 不再每列单独卡片化 (外层 .meetingDetails 已是卡片) */
			.left,
			.center {
				flex: 2;
				padding: 4px 8px;

				.el-col >div {
					background: #f4f6f9;
				}
			}

			.center {
				flex: 1;

				.el-col >div {
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			.right {
				flex: 1;
				max-width: 320px;
				min-width: 260px;
				padding: 4px 8px;
				/* 左侧细分隔线, 区分图片区 */
				border-left: 1px solid #f0f2f7;

				/* 图片区: label 留在上方更直观, 不强制同行 */
				.el-col {
					display: block;

					>p {
						width: auto;
						margin-bottom: 6px;
					}

					>div {
						background: transparent;
						padding: 0;
					}
				}
			}
		}

		.participationLink {
			.row {
				display: flex;
				justify-content: space-around;   /* 三等分均匀分布 */
				gap: 16px;
				flex-wrap: wrap;

				.col {
					flex: 1;
					min-width: 0;
					display: flex;
					flex-direction: column;
					align-items: center;          /* 每列内容居中, 不再左对齐 */
				}
			}

			.qrcode,
			.linkUrl {
				margin-bottom: 20px;
				display: flex;
				flex-direction: column;
				align-items: center;

				h4 {
					font-size: 16px;
					margin: 0 0 10px;
					width: auto;
					text-align: center;
					font-weight: 600;
					color: #1a1a2e;

					span {
						display: block;
						margin-top: 4px;
						font-size: 12px;
						color: #999;
						font-weight: normal;
					}
				}

				img {
					display: block;
					width: 220px;
					height: 220px;
					border-radius: 8px;
					box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
					cursor: pointer;
				}

				span {
					font-size: 13px;
				}
			}

			.options {
				display: flex;
				justify-content: center;

				.el-button {
					width: 200px;
				}


			}
		}

		.postMeetingUpload {
			display: flex;
			flex-direction: row;
			justify-content: center;

			.personalSettlement,
			.supplierSettlement {
				display: flex;
				justify-content: center;
				align-items: flex-start;
				flex-wrap: wrap;

				.card {
					margin: 30px;
					width: 300px;
					min-height: 320px;
					height: auto;
					padding: 30px;
					display: flex;
					text-align: center;
					flex-direction: column;
					align-items: center;
					justify-content: flex-start;
					cursor: pointer;
					border: 2px solid #f2f2f2;
					border-radius: 15px;
					font-size: 20px;
					color: #999;
					transition: all .3s;

					i {
						font-size: 200px;
						color: #f2f2f2;
						transition: all .3s;
					}


					&:hover {
						color: #0065FF;

						i {
							color: #0065FF;
						}
					}
				}
			}

			// flex-wrap: wrap;

			/* .row {
				margin-bottom: 20px;
				width: 100%;
				padding: 20px 20px;
				border-radius: 20px;
				box-shadow: 0 2px 18px rgba(203, 203, 203, 0.31);

				p {
					font-size: 18px;
					color: #112950;

					.error {
						font-size: 14px;
						margin-left: 10px;
						color: darkred;
					}

					.el-tooltip {
						font-size: 14px;
						margin-left: 10px;
					}
				}

				.rowTit {
					display: flex;
					align-items: center;
					margin-bottom: 10px;

					p {
						flex: 1;
					}
				}
			}

			.fileList {
				.fileRow {
					display: flex;
					align-items: center;
					justify-content: space-between;
					transition: all .3s;
					margin-bottom: 10px;

					b {
						font-size: 14px;
						font-weight: normal;
						cursor: pointer;
						display: flex;
						align-items: center;

						i {
							font-size: 16px;
							margin-right: 4px;
						}

						.el-icon-picture {
							color: blueviolet;
						}

						.el-icon-files {
							color: darkorange;
						}
					}

					.del {
						display: none;
						cursor: pointer;

						i {
							font-size: 16px;
						}
					}

					.fileType {
						display: block;
						color: green;
					}

					&:last-child {
						margin-bottom: 0;
					}

					&:hover {
						background-color: #f5f5f5;

						.del {
							display: block;
							color: red;
						}

						.fileType {
							display: none;
						}
					}
				}
			} */

		}

		.conferenceReplay {
			.crBox {
				width: 100%;
				padding: 20px;
				box-shadow: 0px 2px 13px rgba(203, 203, 203, 0.31);
				border-radius: 20px;

				.opts {
					display: flex;
					align-items: center;
					justify-content: flex-end;

					.upload {
						margin: 0 10px;
					}
				}
			}

			.el-row {
				padding: 10px 0;
				margin-bottom: 20px;
				display: flex;
				align-items: center;
			}

			.tabTitle {
				border-bottom: 2px solid #eee;
				width: 100%;

				* {
					font-size: 16px;
				}

				.el-col {
					text-align: center;
					border-right: 1px solid #ccc;

					&:last-child {
						border-right: none;
					}
				}
			}

			.tabContent {
				border-radius: 10px;
				box-shadow: 0px 2px 13px rgba(203, 203, 203, 0.31);
				width: 100%;

				* {
					font-size: 15px;
				}

				.el-col {
					padding: 10px 20px;
					text-align: center;
				}

				.preTax {
					padding: 5px 20px;
					border-radius: 20px;
					background-color: #F1F6FC;
					box-shadow: 0 0 14px rgba(0, 0, 0, 0.1);
				}

				.afterTax {
					padding: 5px 20px;
					border-radius: 20px;
					background-color: #F1FCF5;
					box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
				}
			}

			.endNode {
				border-radius: 10px;
				width: 100%;
				margin: 0;

				* {
					font-size: 16px;
					color: #0068FF;
				}

				.el-col {
					padding: 10px 20px;
					text-align: center;
				}

				.preAmount {
					font-size: 20px;
				}

				.amount {
					font-size: 20px;
				}
			}
		}

		.livePlayback {
			width: 100%;
			padding: 20px;
			border-radius: 20px;
			box-shadow: 0px 2px 13px rgba(203, 203, 203, 0.31);


		}

		.options {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			margin-top: 20px;

			.el-button {
				// width: 280px;
				// height: 50px;
				margin: 0 10px;
				font-size: 16px;
			}

			.el-link {
				.el-link--inner {
					display: flex;
					align-items: center;
					font-size: 16px;
				}

				.el-icon-check {
					border-radius: 5px;
					border: 1px solid #67C23A;
					margin-right: 5px;
				}
			}
		}
	}

	.el-dropdown-menu.el-popper.menu {
		padding: 0;

		.el-dropdown-menu__item {
			margin: 10px;
			padding: 0;

			.el-button {
				width: 100%;
			}
		}
	}

	::v-deep .projectSchedule {
		.el-dialog {
			margin: 0 auto !important;
			overflow: hidden;
			max-height: 90vh;
			overflow-y: auto;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			.el-dialog__body {
				padding: 0 30px;

				.item {
					display: flex;
					align-items: flex-start;
					border-bottom: 1px solid #eee;
					padding: 10px 0;

					.time,
					.status {
						flex: 1;
					}

					.time {
						height: 40px;
						align-items: center;
						margin-right: 20px;

						.el-date-editor.el-input {
							width: 100%;
							height: 100%;

							.el-input__inner {
								height: 100%;
							}
						}
					}

					.status {
						flex: 2;
						display: flex;
						flex-direction: column;

						.type {
							height: 40px;
							display: flex;
							align-items: center;
							margin-bottom: 10px;
						}
					}
				}
			}
		}


	}

	::v-deep .changeDetailOfServices {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		margin: 0 !important;
		max-height: 95vh;
		overflow: hidden;
		overflow-y: auto;

		.el-dialog__body {
			display: flex;
			flex-direction: column;
			justify-content: center;
			padding-top: 10px;
		}

		.DetailOfServicesForm {
			.el-form-item {
				margin-bottom: 10px;
			}

			.el-form-item__label {
				padding-bottom: 5px;
				line-height: 20px;
			}

			.formFooter {
				text-align: center;
			}
		}
	}

	::v-deep .settleAccounts {

		.el-dialog__body {
			padding-bottom: 10px;
		}

		.tips {
			background-color: #f6cdbb;
			padding: 20px;
			border-radius: 10px;

			h3 {
				margin-bottom: 10px;
			}

			p {
				margin-bottom: 5px;

				b {
					color: red;
				}
			}
		}
	}

	::v-deep .agreementDialog {
		margin: 0 !important;
		max-height: 95vh;
		overflow: hidden;
		overflow-y: auto;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;

		.el-dialog__body {
			flex: 1;

			video {
				display: block;
				margin: auto;
				width: 100%;
				height: 100%;
				max-height: 600px;

			}
		}

		.pages {
			text-align: center;
		}

		.opts {
			margin-top: 10px;
			display: flex;
			align-items: center;
			justify-content: space-around;
		}
	}

	::v-deep .fileLog {
		margin: 0 !important;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 90vw;
		max-height: 90vh;
		overflow-y: auto;

		.pdgBox {
			.pages {
				text-align: center;
			}

			.opts {
				display: flex;
				align-items: center;
				justify-content: space-around;
			}
		}
	}

	/* ==================== 截图浏览样式 ==================== */
	.screenshotGallery {
		padding: 16px;

		.screenshot-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;
			padding-bottom: 12px;
			border-bottom: 2px solid #f0f2f5;

			h3 {
				margin: 0;
				font-size: 18px;
				color: #303133;

				i {
					margin-right: 8px;
					color: #409EFF;
				}
			}
		}

		.empty-screenshots {
			padding: 60px 0;
			text-align: center;
		}

		.screenshot-grid {
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
			gap: 20px;
		}

		.screenshot-card {
			border: 1px solid #ebeef5;
			border-radius: 10px;
			overflow: hidden;
			transition: all 0.3s ease;
			background: #fff;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

			&:hover {
				transform: translateY(-4px);
				box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
				border-color: #409EFF;
			}

			.screenshot-img-wrap {
				position: relative;
				width: 100%;
				height: 180px;
				background: #f5f7fa;
				overflow: hidden;

				.screenshot-img {
					width: 100%;
					height: 100%;
					cursor: pointer;
				}

				.image-slot {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					width: 100%;
					height: 100%;
					color: #909399;
					font-size: 14px;
				}

				.screenshot-cover-badge {
					position: absolute;
					top: 8px;
					right: 8px;
					background: linear-gradient(135deg, #f7ba2a, #e6a23c);
					color: #fff;
					padding: 4px 10px;
					border-radius: 20px;
					font-size: 12px;
					font-weight: bold;
					box-shadow: 0 2px 6px rgba(230, 162, 60, 0.4);

					i {
						margin-right: 2px;
					}
				}
			}

			.screenshot-info {
				padding: 12px 14px 8px;

				.screenshot-desc {
					font-size: 13px;
					color: #606266;
					margin: 0 0 4px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.screenshot-time {
					font-size: 12px;
					color: #909399;
					margin: 0 0 2px;
				}

				.screenshot-size {
					font-size: 12px;
					color: #c0c4cc;
					margin: 0;
				}
			}

			.screenshot-actions {
				padding: 8px 14px 14px;
				display: flex;
				gap: 8px;

				.el-button {
					flex: 1;
				}
			}
		}
	}
</style>